import { render } from "./mastercard_match_inquiry.html?vue&type=template&id=186f0618&external"
import script from "./mastercard_match_inquiry.js?vue&type=script&lang=js&external"
export * from "./mastercard_match_inquiry.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__